import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { TextUtils } from '../../../shared/utils/text-utils';

@Injectable()
export class TranslatedDateAdapter extends NativeDateAdapter {

  constructor(matDateLocale: string, platform: Platform) {
    super(matDateLocale, platform);
  }

  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    // Return 3-letter uppercase abbreviations for all styles
    return [
      this.getTranslation('text_jan', 'JAN'),
      this.getTranslation('text_feb', 'FEB'),
      this.getTranslation('text_mar', 'MAR'),
      this.getTranslation('text_apr', 'APR'),
      this.getTranslation('text_may', 'MAY'),
      this.getTranslation('text_jun', 'JUN'),
      this.getTranslation('text_jul', 'JUL'),
      this.getTranslation('text_aug', 'AUG'),
      this.getTranslation('text_sep', 'SEP'),
      this.getTranslation('text_oct', 'OCT'),
      this.getTranslation('text_nov', 'NOV'),
      this.getTranslation('text_dec', 'DEC')
    ];
  }

  private getTranslation(key: string, fallback: string): string {
    const text = TextUtils.getText(key);
    return (text && text !== key) ? text : fallback;
  }

  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    if (style === 'long') {
      return [
        this.getTranslation('text_sunday', 'Sunday'),
        this.getTranslation('text_monday', 'Monday'),
        this.getTranslation('text_tuesday', 'Tuesday'),
        this.getTranslation('text_wednesday', 'Wednesday'),
        this.getTranslation('text_thursday', 'Thursday'),
        this.getTranslation('text_friday', 'Friday'),
        this.getTranslation('text_saturday', 'Saturday')
      ];
    }
    if (style === 'short') {
      // 3-letter abbreviations
      return [
        this.getTranslation('text_sun', 'Sun'),
        this.getTranslation('text_mon', 'Mon'),
        this.getTranslation('text_tue', 'Tue'),
        this.getTranslation('text_wed', 'Wed'),
        this.getTranslation('text_thu', 'Thu'),
        this.getTranslation('text_fri', 'Fri'),
        this.getTranslation('text_sat', 'Sat')
      ];
    }
    // narrow style (single letter) - use first character of translated day name
    return [
      this.getTranslation('text_sunday', 'Sunday').charAt(0),
      this.getTranslation('text_monday', 'Monday').charAt(0),
      this.getTranslation('text_tuesday', 'Tuesday').charAt(0),
      this.getTranslation('text_wednesday', 'Wednesday').charAt(0),
      this.getTranslation('text_thursday', 'Thursday').charAt(0),
      this.getTranslation('text_friday', 'Friday').charAt(0),
      this.getTranslation('text_saturday', 'Saturday').charAt(0)
    ];
  }

  override format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'monthYearLabel') {
      // Format for calendar header: "MAY 2026" or "MAG 2026"
      const monthIndex = this.getMonth(date);
      const year = this.getYear(date);
      const monthNames = [
        this.getTranslation('text_jan', 'JAN'),
        this.getTranslation('text_feb', 'FEB'),
        this.getTranslation('text_mar', 'MAR'),
        this.getTranslation('text_apr', 'APR'),
        this.getTranslation('text_may', 'MAY'),
        this.getTranslation('text_jun', 'JUN'),
        this.getTranslation('text_jul', 'JUL'),
        this.getTranslation('text_aug', 'AUG'),
        this.getTranslation('text_sep', 'SEP'),
        this.getTranslation('text_oct', 'OCT'),
        this.getTranslation('text_nov', 'NOV'),
        this.getTranslation('text_dec', 'DEC')
      ];
      return `${monthNames[monthIndex]} ${year}`;
    }
    return super.format(date, displayFormat);
  }
}
